import React from 'react';
import { Box } from 'grommet';
import { SplashSearch2 } from 'app/grommetComponents/ZipCodeSearch/SplashSearch.js';

export const SearchPage = () => {
  // const theme = useContext(ThemeContext);
  // const { pageBackgroundColor } = theme.global.colors;
  return (
    <Box fill align={'center'} justify={'center'} background={'pageBackgroundColor'}>
      <SplashSearch2 isCompact={false} />
    </Box>
  )
}
